import { render, staticRenderFns } from "./EditNewsPage.vue?vue&type=template&id=37bc8024&"
import script from "./EditNewsPage.vue?vue&type=script&lang=ts&"
export * from "./EditNewsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports